.feedback {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-4);
  margin-top: var(--tuna-spacing-3);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

.headline {
  margin: 0;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 700;
  line-height: 1.5;
}

.body {
  display: flex;
  align-items: baseline;
  gap: var(--tuna-spacing-1);
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: 1.5;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.chip {
  display: flex;
  align-items: baseline;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  font-size: var(--tuna-typography-body2-fontSize);
}

.chipIndex {
  color: var(--tuna-content-muted);
  font-variant-numeric: tabular-nums;
}

.chipBand {
  font-weight: 700;
}

.chipStability {
  color: var(--tuna-content-muted);
}

.score {
  font-size: var(--tuna-typography-fontSize-4xl);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--tuna-spacing-2);
}

.readout {
  margin: 0;
  font-family: var(--tuna-typography-mono-fontFamily);
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
  font-variant-numeric: tabular-nums;
}

/* The verdict takes focus when the take ends, so it is announced and a keyboard user continues from it */
.verdict {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-borderRadius);
}

.verdict:focus:not(:focus-visible) {
  outline: none;
}

/* Announced, not shown */
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
